import React from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

const styles = (theme) => ({
  root: {
    width: "100%",
    overflowY: "auto",
    flexGrow: 1,
    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
  },
});

class ParticipantListScroll extends React.PureComponent {
  componentDidMount() {
    this.node.scrollTop = this.node.scrollHeight;
  }

  getSnapshotBeforeUpdate() {
    return (
      this.node.scrollTop + this.node.offsetHeight === this.node.scrollHeight
    );
  }

  componentDidUpdate(prevProps, prevState, shouldScroll) {
    if (shouldScroll) {
      this.node.scrollTop = this.node.scrollHeight;
    }
  }

  render() {
    const { children, classes } = this.props;
    return (
      <div
        className={classes.root}
        ref={(node) => {
          this.node = node;
        }}
      >
        {children}
      </div>
    );
  }
}

ParticipantListScroll.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.object,
};

export default withStyles(styles)(ParticipantListScroll);
